<template>
  <div class="content marketing">
    <div id="marketingWrapper">
      <div id="chartWrapper">
        <div class="col">
          <div class="chart">
            <RandomDoughnut :height="chartHeight" />
          </div>
          <div class="chart">
            <RandomLineChart :height="chartHeight" />
          </div>
        </div>
        <div class="col">
          <MyChart :height="chartHeight" :styles="chartWrapperStyles" />
        </div>
      </div>
    </div>
    <h1>We market your ideas, and measure the results</h1>
    <div class="article">
      <h4>Online Marketing</h4>
      <p>The internet allows us to reach a truly global audience. It also allows us to gain powerful insight into a websites audience, all while respecting privacy. Where is the user located? What pages or products are they spending the most time viewing? How did they find your website in the first place?</p>

      <p>By carefully observing how the end user interacts with your website, we learn the users interests. We learn how to improve their experience, and can ensure that the products or content they are interested in are the ones they can easily find. Privacy is critical, and we won't sell or abuse critical data. Our goal is to help the end user become a paying customer, which is why they visited your website.</p>

      <h4>SEO: Search Engine Optimization</h4>

      <p>Google and the other popular search engines have forever transformed how we use the internet. By optimizing your website for the search engines, they will better understand your content and products, and will display your website more prominently in the the search results. Bamboodev carefully optimizes our client websites and applications for search engines and humans both.</p>

      <h4>SEM: Search Engine Marketing</h4>

      <p>Paid advertising is an incredibly effective technique to increase site traffic, often with immediate results. By combining the online ads with usage analysis, we can quickly discern which ad campaigns are most effective. Unlike most "marketing consulatants", Bamboodev includes easy to understand reports detailing your ad campaings and their real-world results.</p>

      <p>
        Still not convinced? Take a look at what
        <router-link to="/caseStudies">our clients</router-link>&nbsp;have to say.
      </p>
    </div>
  </div>
</template>

<script>
import MyChart from "@/components/MyChart.vue";
import RandomDoughnut from "@/components/RandomDoughnut.vue";
import RandomLineChart from "@/components/RandomLineChart.vue";

export default {
  name: "marketing",
  data() {
    return {
      chartHeight: 300,
      chartWrapperStyles: {
        margin: "10vh 0 0"
      }
    };
  },
  components: {
    MyChart,
    RandomDoughnut,
    RandomLineChart
  },
  computed: {}
};
</script>

<style lang="scss">
.marketing {
  #marketingWrapper {
    width: 100vw;
    height: 600px;
    // border: 1px solid pink;
    position: fixed;
  }
  #chartWrapper {
    display: flex;
    .col {
      width: 100%;
    }
    .chart {
      // border: 1px solid red;
      margin-top: 100px;
    }
    .chart:nth-child(2) {
      margin-top: 50px;
    }
  }
  // .article {
  // background-color: #10354b;
  // }
}
@media screen and (max-width: 700px) {
  .marketing.content {
    // display: none;
    // // padding-top: 100px;
    display: block;
    // // padding-top: 60vh;
    h1 {
      display: inline;
      bottom: inherit;
      left: inherit;
      position: unset;
      width: 100%;
      z-index: 100;
    }
    h4 {
      padding: 0 30px;
    }
    .article {
      display: inline;
      width: 90vw;
      padding: 0px 30px;
      // top: 90vh;
      margin-top: 0px;
      p {
        padding: 0 30px;
      }
    }
    #marketingWrapper {
      // display: none;
      //   width: 100vw;
      //   overflow-x: hidden;
      padding-top: 100px;
      height: 400px;
      position: unset;
    }
    .col:nth-child(1) .chart:nth-child(1) {
      display: none;
    }
    .col:nth-child(2) {
      display: none;
    }
  }
}
</style>